import axios from "@axios";
import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReceipts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/stock_receipts", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProductsBySupplierId(ctx, { supplierId }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/suppliers/${supplierId}/products`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchReceipt(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/stock_receipts/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addReceipt(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/stock_receipts", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateReceipt(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/stock_receipts", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteReceipt(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/stock_receipts", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
